import { render } from "./TheProductivityCardBackup.vue?vue&type=template&id=d9c45180"
import script from "./TheProductivityCardBackup.vue?vue&type=script&lang=js"
export * from "./TheProductivityCardBackup.vue?vue&type=script&lang=js"

import "./TheProductivityCardBackup.vue?vue&type=style&index=0&id=d9c45180&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__